// ============================================================================
// Service Type Configuration
// ============================================================================

export interface ServiceTypeConfig {
  icon: string;
  labelKey: string;
}

/** Map service type → icon + i18n label key. */
export const SERVICE_TYPE_CONFIG: Record<string, ServiceTypeConfig> = {
  grooming: {
    icon: 'tabler:scissors',
    labelKey: 'orders.serviceTypes.grooming',
  },
  walking: { icon: 'tabler:shoe', labelKey: 'orders.serviceTypes.walking' },
  daycare: { icon: 'tabler:sun', labelKey: 'orders.serviceTypes.daycare' },
  boarding: { icon: 'tabler:bed', labelKey: 'orders.serviceTypes.boarding' },
  petsitting: {
    icon: 'tabler:home',
    labelKey: 'orders.serviceTypes.petsitting',
  },
  training: {
    icon: 'tabler:school',
    labelKey: 'orders.serviceTypes.training',
  },
  transport: {
    icon: 'tabler:truck',
    labelKey: 'orders.serviceTypes.transport',
  },
  vet: { icon: 'tabler:stethoscope', labelKey: 'orders.serviceTypes.vet' },
  online_vet: {
    icon: 'tabler:video',
    labelKey: 'orders.serviceTypes.online_vet',
  },
};

/** Get icon for a service type, with fallback. */
export function getServiceTypeIcon(serviceType: string | undefined): string {
  return (
    SERVICE_TYPE_CONFIG[serviceType ?? '']?.icon ?? 'tabler:clipboard-list'
  );
}

/** Get i18n label key for a service type, with fallback. */
export function getServiceTypeLabelKey(
  serviceType: string | undefined,
): string {
  return (
    SERVICE_TYPE_CONFIG[serviceType ?? '']?.labelKey ?? 'orders.unknownService'
  );
}

// ============================================================================
// Shared App Constants
// ============================================================================

/** Team / role display labels. */
export const ROLE_LABELS: Record<string, string> = {
  owner: 'Owner',
  manager: 'Manager',
  member: 'Team Member',
};

/** Default service duration in minutes when none is specified. */
export const DEFAULT_SERVICE_DURATION_MIN = 60;

/** 15-min time slots (00:00–23:45, full day). Used by booking modals. */
function generateFullDayTimeSlots(): string[] {
  const slots: string[] = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 15) {
      slots.push(
        `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`,
      );
    }
  }
  return slots;
}
export const CONSOLE_TIME_SLOTS = generateFullDayTimeSlots();

/** Display label for a location (name, city, or address). */
export function getLocationDisplayLabel(
  loc: { name?: string; city?: string; address?: string } | null | undefined,
): string {
  return loc?.name || loc?.city || loc?.address || 'Location';
}
